'use client';

interface FooterProps {
  onLegalClick: (type: 'privacy' | 'terms' | 'refund' | 'delivery') => void;
}

export default function Footer({ onLegalClick }: FooterProps) {
  const year = new Date().getFullYear();

  return (
    <footer style={{ background: '#0D1A3A', color: '#fff' }}>
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Company */}
          <div className="lg:col-span-2">
            <div className="mb-4">
              <span
                style={{
                  fontFamily: '"DM Sans", sans-serif',
                  fontWeight: 800,
                  fontSize: '20px',
                  color: '#fff',
                  letterSpacing: '-0.02em',
                }}
              >
                CARTELIX
              </span>
              <span
                style={{
                  fontFamily: '"DM Sans", sans-serif',
                  fontWeight: 500,
                  fontSize: '12px',
                  color: 'rgba(255,255,255,0.4)',
                  letterSpacing: '0.12em',
                  marginLeft: 8,
                }}
              >
                LLC
              </span>
            </div>
            <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.55)', lineHeight: 1.7, maxWidth: 320 }}>
              A US-registered digital agency delivering premium web, mobile, social, and branding solutions to international clients since 2016.
            </p>
            <div className="mt-6 space-y-2">
              <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.45)' }}>
                📍 30 N Gould St Ste R, Sheridan, WY 82801
              </p>
              <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.45)' }}>Wyoming, USA</p>
              <a href="mailto:contact@cartelix-llc.com" style={{ fontSize: '13px', color: 'rgba(255,255,255,0.6)', display: 'block' }}>
                ✉️ contact@cartelix-llc.com
              </a>
              <a href="tel:+13345831026" style={{ fontSize: '13px', color: 'rgba(255,255,255,0.6)', display: 'block' }}>
                📞 +1 (334) 583-1026
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <p className="font-heading font-bold text-sm mb-5" style={{ color: '#fff', letterSpacing: '0.04em' }}>
              Services
            </p>
            <ul className="space-y-3">
              {['Website Creation', 'Mobile Apps', 'Social Media Posts', 'Rebranding'].map((s) => (
                <li key={s}>
                  <a
                    href="#services"
                    style={{ fontSize: '13.5px', color: 'rgba(255,255,255,0.5)', transition: 'color 0.2s' }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = '#fff')}
                    onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(255,255,255,0.5)')}
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <p className="font-heading font-bold text-sm mb-5" style={{ color: '#fff', letterSpacing: '0.04em' }}>
              Legal
            </p>
            <ul className="space-y-3">
              {[
                { label: 'Privacy Policy', type: 'privacy' as const },
                { label: 'Terms of Service', type: 'terms' as const },
                { label: 'Refund Policy', type: 'refund' as const },
                { label: 'Delivery Policy', type: 'delivery' as const },
              ].map((item) => (
                <li key={item.label}>
                  <button
                    onClick={() => onLegalClick(item.type)}
                    style={{ fontSize: '13.5px', color: 'rgba(255,255,255,0.5)', background: 'none', border: 'none', cursor: 'pointer', padding: 0, transition: 'color 0.2s', textAlign: 'left' }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = '#fff')}
                    onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(255,255,255,0.5)')}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div style={{ height: 1, background: 'rgba(255,255,255,0.08)', marginBottom: 24 }} />

        {/* Bottom bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p style={{ fontSize: '12.5px', color: 'rgba(255,255,255,0.35)' }}>
            © {year} CARTELIX LLC. All rights reserved. Registered in Wyoming, USA.
          </p>
          <div className="flex items-center gap-4">
            <span
              className="px-3 py-1.5 rounded-full text-xs font-semibold"
              style={{ background: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.4)', border: '1px solid rgba(255,255,255,0.08)' }}
            >
              🔒 SSL Secured
            </span>
            <span
              className="px-3 py-1.5 rounded-full text-xs font-semibold"
              style={{ background: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.4)', border: '1px solid rgba(255,255,255,0.08)' }}
            >
              🏛️ Wyoming LLC
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}